/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'thumb_down': {
    width: 16,
    height: 16,
    viewBox: '0 0 22 20',
    data: '<path pid="0" d="M14 0H5a1.987 1.987 0 0 0-1.84 1.22L.14 8.27A1.976 1.976 0 0 0 0 9v1.91l.01.01L0 11a2.006 2.006 0 0 0 2 2h6.31l-.95 4.57-.03.32a1.505 1.505 0 0 0 .44 1.06L8.83 20l6.59-6.59A1.988 1.988 0 0 0 16 12V2a2.006 2.006 0 0 0-2-2zm4 0v12h4V0z" fill-rule="evenodd"/>'
  }
})
